<template>  
  <div>
      <q-list-header class="text-weight-bold">Event Erfassen</q-list-header>
      <div class="dialog">
        <q-btn
            icon="cached"
            color="primary"
            :label="gpsButtonText"
            @click="getGps()">
            <q-chip v-if="gpsPosition" floating :color="gpsColor">Meter: {{ Math.round(gpsPosition.accuracy) }}</q-chip>
        </q-btn>   
      
        <div class="dialog">Photo oder QR Scan: </div> 
        <div class="dialog" @click="capture()">
            <qrcode-reader ref="qread" @decode="onDecode" :paused="paused" :camera="{ facingMode: 'environment' }"></qrcode-reader>
        </div>  
        <canvas ref="canvas" id="canvas" width="640" height="480"></canvas>
        <span v-if="selectedCapture" slot="subtitle">Size KB: {{Math.round(this.selectedCapture.length / 1024)}}</span> 
        &nbsp;
        <q-btn v-if="paused" size="sm"   color="primary" v-on:click="paused = false">Camera Starten</q-btn>    
        <p></p> 
        <q-datetime v-model="eventTime" type="datetime" float-label="Event Zeit" format="D.MMM.YYYY HH:mm" />
        <q-select
            v-model="select"
            float-label="Event Type"
            :options="selectOptions"
        />
        <q-input v-if="qrScan" class="comment" :readonly="true" v-model="qrScan" rows="2" float-label="QR Scan" type="textarea" />            
        <q-input class="comment" v-model="eventText" rows="2" float-label="Komentar" type="textarea" />  
        <p></p>
        <div class="dialog" v-if="selectedCapture && select">
        <q-btn class="dialog" color="negative" v-on:click="cancelRequest">Cancel</q-btn>
        &nbsp;
        <q-btn 
            class="dialog" 
            color="positive" 
            :loading="loading"
            v-on:click="sendRequest">
             Send
        </q-btn>
        </div>
      </div>
  </div>
</template>

<script>
import { Cookies } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialog2',
  data () {
    return {
      eventTime: new Date(),
      video: {},
      canvas: {},
      captures: [],
      selectedCapture: null,
      stream: {},
      makePic: false,
      cameraStart:true,
      width: 320,
      heigth: 160,
      gpsButtonText: 'Gps Position',
      gpsPosition: null,
      gpsColor: 'positive',
      paused: false,
      selectOptions: [],
      select: null,
      eventText: '',
      qrScan: null,
      form: {
        SessionId: null,
        action: 'SendPic',
      },
      loading: false,
    }
  },
  mounted() {
    this.getGps()
    this.loadEventType()
  },
  methods: {
    capture () {
     
      var qread = this.$refs.qread
      var canvas = this.$refs.canvas
      var ctx= canvas.getContext('2d')
      var vid = qread.$refs.video 
      ctx.drawImage(vid,0,0);
      this.selectedCapture = canvas.toDataURL("image/png")      
      qread = null
      canvas = null
      ctx = null
      vid = null
      this.paused = true

    },
    getGps (){
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }

      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(position => {
          //this.positions.push(position.coords);
          this.gpsPosition = position.coords
          this.gpsButtonText = "GPS Position Found"
          
          if(position.coords.accuracy >= 20)
            this.gpsColor = 'negative'
          else
            this.gpsColor = 'positive'

          console.log(position)
        }, error, options)
      }
       else {
         alert("Geolocation is not supported by this browser.")
      }
    },
    cancelRequest () {
            this.$q.notify('event report has not been sent.')
            this.selectedCapture = null
            this.eventText = ''
            eventBus.$emit('closeDialog', null)

    },

    loadEventType () {
    this.form.SessionId = this.$store.state.session.SessionId
    this.form.action = "GetEventTypes"
    axios.post(this.$apiUrl,
    qs.stringify(this.form),
    {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(response => {
        console.log(response)
        if(response.status == 200){ 
            this.selectOptions = response.data
            //This is a temp solution to select the last one as a default.
            //We probably need to introduce a 'default event type'  but we do not have that yet
            if(this.selectOptions.length > 0){
                var selOpt = this.selectOptions
                this.select = selOpt[selOpt.length - 1].value
            }
        }
        else{
            this.$q.notify('Something Wrong.')
        }
    })
    .catch(e => {        
      this.$q.notify('Something Wrong.')      
      console.log(e);
    })
    },

    sendRequest () {
      this.loading = true
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "SendPic"
      this.form.lat = this.gpsPosition.latitude
      this.form.lng = this.gpsPosition.longitude
      this.form.accuracy = this.gpsPosition.accuracy
      this.form.Pic = this.selectedCapture
      this.form.comment = this.eventText
      this.form.qrscan = this.qrScan
      this.form.IdEventType = this.select
     
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          this.loading = false
          if(response.status == 200){ 
              if(response.data == 'OK'){
                this.$q.notify({ message: 'Ereignis Report gesendet', type: 'positive' })
                this.selectedCapture = null
                this.eventText = ''
                this.qrScan = null
                eventBus.$emit('closeDialog', null)
                eventBus.$emit('addEvent', null)
                this.$router.push({name: 'Journal'})
                      }
              else{
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {  
         this.loading = false      
        this.$q.notify('Something Wrong.')      
        console.log(e);
      })
    },
    onDecode (decodedString) {
        this.qrScan = decodedString
        this.capture()
    },
    sendPic(){
      alert('send pic')
    }
  }
}
 


function gotDevices(deviceInfos){
  var DeviceId = "";
  for (var i = 0; i !== deviceInfos.length; ++i) {
    var deviceInfo = deviceInfos[i];
    if (deviceInfo.kind == 'videoinput')
    {
        console.log('DeviceInfo: ' + deviceInfo)
        DeviceId = deviceInfo.deviceId
    }
  }
  console.log("DeviceId: " + DeviceId)
  var constraints = { deviceId: { exact: DeviceId } };

 var supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
      if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({ video: constraints }).then(stream => {
              self.stream = stream
              //this.video.src = window.URL.createObjectURL(stream);
              self.video.srcObject = stream;
              self.video.play();
              self.makePic = true;
          });
      }


}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}


</script>

<style scoped>
       
    #video {
        background-color: #000000;
    }
    #canvas {
        display: none;
    }
    li {
        display: inline;
        padding: 5px;
    }
    

    .imgdisp{
        background-color: aqua;
        height: 100%;
        width: 100%;
        object-fit: contain
        
    }
    .dialog{
        padding: 5px;
    }
    .videoRapper{
        height: 320px;
        width:  240px;
    }

    .comment{
      background-color:lightgray;
    }
    

</style>